import { classNames } from "@/react/helpers/twMergeWithCN";
import { useCircleV4 } from "@/react/hooks/useCircleV4";

import { MemberCardWithConnectionSkeleton } from "./MemberCardWithConnectionSkeleton";

const DEFAULT_ITEM_COUNT = 6;

interface CardViewSkeletonProps {
  count?: number;
}

export const CardViewSkeleton = ({
  count = DEFAULT_ITEM_COUNT,
}: CardViewSkeletonProps) => {
  const { isCircleV4 } = useCircleV4();
  return (
    <ol
      className={classNames(
        "m-4 grid w-full list-none auto-rows-fr grid-cols-[repeat(auto-fill,minmax(218px,1fr))] gap-5 md:m-0 lg:m-auto",
        isCircleV4 && "grid-cols-[repeat(auto-fill,229px)] gap-4",
      )}
      data-testid="directory_members_grid_skeleton"
    >
      {Array.from({ length: count }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key -- No need to use a unique key
        <MemberCardWithConnectionSkeleton key={index} />
      ))}
    </ol>
  );
};
